/*
 * ELASTICSEARCH CONFIDENTIAL
 * __________________
 *
 *  Copyright Elasticsearch B.V. All rights reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Elasticsearch B.V. and its suppliers, if any.
 * The intellectual and technical concepts contained herein
 * are proprietary to Elasticsearch B.V. and its suppliers and
 * may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright
 * law.  Dissemination of this information or reproduction of
 * this material is strictly forbidden unless prior written
 * permission is obtained from Elasticsearch B.V.
 */

import { useEuiTheme } from '@elastic/eui'

export type CapacityColorGetter = (capacity?: number, alternate?: boolean) => string

export const useCapacityColorPicker = (): CapacityColorGetter => {
  const { euiTheme } = useEuiTheme()
  const unknownColor = euiTheme.colors.darkShade

  const baseColors: Map<number, string> = new Map([
    [1024 * 64, euiTheme.colors.vis.euiColorVis8],
    [1024 * 58, euiTheme.colors.vis.euiColorVis8],
    [1024 * 32, euiTheme.colors.vis.euiColorVis2],
    [1024 * 16, euiTheme.colors.vis.euiColorVis7],
    [1024 * 8, euiTheme.colors.vis.euiColorVis3],
    [1024 * 4, euiTheme.colors.vis.euiColorVis5],
    [1024 * 2, euiTheme.colors.vis.euiColorVis1],
    [1024, euiTheme.colors.vis.euiColorVis0],
  ])

  const getCapacityColor = (capacity, alternate = false) => {
    const baseColor = (capacity && baseColors.get(capacity)) || unknownColor

    if (alternate) {
      return `${baseColor}80` // #abcabc80, where 80 is 50% opacity in hex colors
    }

    return baseColor
  }

  return getCapacityColor
}
